export enum LoanSummarySectionTypes {
  borrowerInformation = 0,
  loanInformation = 1,
  propertyInformation = 2,
  employmentInformation = 3,
  liabilities = 4,
}
